<template>
  <div>
    <div v-if="beforeconfirm">
      <div class="item-box">
        <div class="item-body disFlex Flex-center pt20">
          <div class="item-left">
            <img
              :src="couponDetail.brandLogo?couponDetail.brandLogo:'https://j.weizan.cn/youxiang/images/avatar_default.jpg'"
              class="item-img"
            />
          </div>
          <div class="item-right disFlex vertical">
            <div class="item-top disFlex Flex-center Flex-between">
              <div class="item-title pt20">{{couponDetail.name}}</div>
              <!-- <div class="item-num">x{{orderDetail.num}}</div> -->
            </div>
            <div class="item-detail disFlex Flex-center Flex-between">
              <div class="price-area disFlex Flex-center mt20">
                <div class="price-detail" v-if="couponDetail.maxAmount > 0">最高减免：<span>￥{{couponDetail.maxAmount}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="couponDetail.rule&&couponDetail.rule.length>0" class="mt20 f fw f16">
          <div
            v-for="(item, index) in couponDetail.rule"
            :key="index"
            class="couponDetail mt5"
          >满{{item[0]}}减{{item[1]}}；</div>
        </div>
      </div>
      <div>
        <van-field v-model="couponDetail.userName" label="姓名:" readonly />
        <van-field v-model="couponDetail.mobile" label="手机号:" readonly />
        <van-field v-model.number="amount" label="转单金额:" maxlength="8" />
      </div>
      <div style="margin: 10px 15px;box-shadow: #e2e4e2 0px 6px 8px -2px;">
        <!-- <router-link to="/kpi"> -->
        <van-button type="info" style="width:100%" @click="verifyCoupon">确 认 核 销</van-button>
        <!-- <van-button type="info" class="mt10" style="width:100%" @click="confirm">切换核销状态</van-button> -->
        <!-- </router-link> -->
      </div>
    </div>
    <!-- 核销结果界面 -->
    <div class="gift disFlex fvc vertical" v-if="!beforeconfirm">
      <!-- 核销部分 -->
      <div>
        <div v-if="checksuccess" class="f fvc v">
          <img src="https://j.weizan.cn/youxiang/check-success.png" class="status-img" />
          <div class="check-status">已核销</div>
          <div class="check-info">核销时间：{{successdetail.finishTime}}</div>
          <div class="check-info">核销导购员：{{successdetail.name}}</div>

          <div class="check-info">核销门店：{{successdetail.shopName||'-'}}</div>
          <div class="check-info">核销品牌：{{successdetail.brandName||'-'}}</div>
          <div class="check-info">转单金额：{{successdetail.changeAmount}}</div>
        </div>
        <div v-if="!checksuccess" class="disFlex fvc vertical">
          <img src="https://j.weizan.cn/youxiang/check-failed.png" class="status-img" />
          <div class="check-status">核销失败</div>
          <div class="check-status mt10" v-if="noAllow">抱歉，您没有当前优惠券的核销权限~</div>
          <router-link :to="{path:'/kpi/ordercancel',query: { act_id: act_id}}" v-if="!noAllow">
            <div class="check-btn">继续核销</div>
          </router-link>
          <div v-else>
            <div class="check-btn" @click.stop.prevent="backHome">返 回</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
      showqrcode: false,
      showDetail: true,
      amount: "",
      phone: "13420191150",
      name: "先辈",
      beforeconfirm: true,
      orderId: 0,
      orderDetail: {
        productName: "商品名称",
        payMethod: null,
        payTime: null,
        userName: null,
        mobile: null,
        seckillPrice: 0,
        salePrice: 0,
        num: 0,
        payStatus: true,
        status: null,
        tradeNo: 0,
        pic: null,
        vo: null,
      },
      couponId: 0,
      tradeNo: "",
      checksuccess: true,
      successdetail: {
        brandName: "",
        changeAmount: 0,
        finishTime: "",
        name: "",
        userName: "",
        mobile: "",
        prizeName: "",
        shopName: "",
      },
      couponDetail: {
        actId: 0,
        id: 0,
        name: "",
        userName: "",
        mobile: "",
        brandId: 0,
        rule: [],
        maxAmount: 0,
        sort: 0,
        status: "",
        brandName: "",
        brandLogo: "",
      },
      noAllow: false,
      userId: 0,
    };
  },
  async created() {
    // http://wx.youxiangzb.com/#/verifyCoupon?actId=1&kpiUserId=1&addition={\"id\":7}
    this.act_id =
      this.$route.query.act_id || localStorage.getItem("act_id");
    if (this.$route.query.addition) {
      var jsondetail = decodeURIComponent(this.$route.query.addition);
      this.couponId = JSON.parse(jsondetail).id;
      this.tradeNo = JSON.parse(jsondetail).tradeNo;
      this.userId = JSON.parse(jsondetail).userId;
      console.log(this.$route.query.addition);
    } else {
      this.$toast("该二维码无效，请核对");
      setTimeout(() => {
        this.$router.push({
          path: "/kpi/ordercancel",
          query: {
            act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
          },
        });
      }, 1000);
    }
  },
  mounted() {
    this.checkAllow();
    this.$initWXSDK(null, () => {
      wx.hideAllNonBaseMenuItem();
    });
  },
  methods: {
    backHome() {
      let tmp = localStorage.getItem("preheatPath") || "prehddd";
      this.$router.push({
        path: tmp,
        query: {
          act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
        },
      });
    },
    confirm() {
      this.beforeconfirm = !this.beforeconfirm;
    },
    // 验证是否有核销权限
    async checkAllow() {
      let res = await this.$http.post(`/v1/apply/check_access`, {
        couponId: this.couponId,
        tradeNo: this.tradeNo,
      });
      console.log(res);

      if (res.data && res.code == 0) {
        this.getOrderDetail();
      } else {
        this.beforeconfirm = false;
        this.checksuccess = false;
        if (res.code == 20555) {
          this.noAllow = true;
        } else if (res.code == 10103) {
          this.noAllow = true;
        } else {
          this.$toast(res.msg);
        }
      }
    },
    // 获取扫码传过来的参数，先查询优惠券信息
    async getOrderDetail() {
      let res = await this.$http.post(
        `/v1/seckill/card/coupon/get?couponId=${this.couponId}&userId=${this.userId}`
      );
      console.log(res);
      if (res.data && res.code == 0) {
        this.couponDetail = res.data;
      }
    },
    // 核销代金券
    async verifyCoupon() {
      if (this.amount == "" && this.amount !== 0) {
        this.$toast("请输入转单金额");
        return;
      }
      if (this.amount != 0 && /^\d+(\.\d{1,2})?$/.test(this.amount) == false) {
        this.$toast("请输入正确转单金额，最多两位小数");
        return;
      }
      let res = await this.$http.post(`/v1/apply/coupon`, {
        changeAmount: this.amount,
        couponId: Number(this.couponId),
        tradeNo: this.tradeNo,
      });
      console.log(res);
      this.beforeconfirm = false;
      if (res.data && res.code == 0) {
        // 此处进行核销结果操作
        this.checksuccess = true;
        this.successdetail = res.data;
        setTimeout(() => {
          this.$router.push({
            path: "/kpi/ordercancel",
            query: {
              act_id:
                this.$route.query.act_id || localStorage.getItem("act_id"),
            },
          });
        }, 10000);
      } else {
        this.$toast(res.msg);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.item-box {
  width: 100%;
  padding: 0 15px 15px;
  background: #fff;
  box-sizing: border-box;
  margin-bottom: 5px;
  .couponDetail {
    width: 45%;
  }
  .item-head {
    height: 41px;
    border-bottom: 1px solid #f5f6f7;
    margin-bottom: 15px;
    .item-id {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(105, 105, 105, 1);
    }
    .item-status {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(0, 48, 120, 1);
    }
  }
  .item-left {
    width: 100px;
    border-radius: 5px;
    position: relative;
    .item-img {
      width: 100px;
      border-radius: 5px;
    }
    .item-data {
      width: 100px;
      height: 22px;
      background: rgba(0, 0, 0, 1);
      opacity: 0.3;
      border-radius: 0 0 5px 5px;
      position: absolute;
      left: 0;
      bottom: 0;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      box-sizing: border-box;
      .num {
        color: #fcff00;
      }
    }
  }
  .item-right {
    width: 100%;
    margin-left: 10px;
    height: 100px;
    .item-info {
      width: 58.5px;
      height: 33px;
      border-radius: 2px;
    }
    .item-num {
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(53, 53, 53, 1);
    }
    .item-title {
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(53, 53, 53, 1);
    }
    .price-detail {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(0, 48, 120, 1);
      span {
        color: red;
        font-size: 20px;
      }
    }
    .options-btn {
      width: 70px;
      height: 24px;
      background: rgba(0, 48, 120, 1);
      border-radius: 12px;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 24px;
      text-align: center;
    }
  }
  .tip {
    font-size: 16px;
  }
}
.gift {
  width: 100%;
  height: 100vh;
  background: #fff;
  padding-top: 67px;
  .gift-img {
    width: 116px;
    height: 116px;
    background: rgba(239, 239, 239, 1);
    border: 3px solid rgba(255, 255, 255, 1);
    box-shadow: 0px 10px 28px 12px rgba(0, 0, 0, 0.04);
    border-radius: 12px;
    margin: 0 auto 20px;
    .img {
      width: 110px;
      height: 110px;
      border-radius: 12px;
    }
  }
  .gift-qrcode {
    width: 150px;
    height: 150px;
    background: rgba(208, 208, 208, 1);
    margin-top: 102px;
  }
  .btn-box {
    position: fixed;
    bottom: 25px;
    width: 100%;
  }
  .page-btn {
    width: 325px;
    height: 44px;
    background: rgba(0, 48, 120, 1);
    border-radius: 22px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(255, 255, 255, 1);
    line-height: 44px;
    text-align: center;
    margin: 0 auto;
  }
  .back-btn {
    width: 133px;
    height: 44px;
    border: 1px solid rgba(0, 48, 120, 1);
    border-radius: 22px;
    line-height: 44px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(0, 48, 120, 1);
    text-align: center;
    background: #fff;
  }
  .gift-title {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(53, 53, 53, 1);
    text-align: center;
    margin-bottom: 19px;
  }
  .gift-info {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(116, 116, 116, 1);
    text-align: center;
    margin: 0 33px;
  }
  .interact-progress {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(53, 53, 53, 1);
    margin: 60px 0 15px;
  }
  .interact-status {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(244, 0, 0, 1);
  }
  .user-avatar {
    width: 40px;
    height: 40px;
    border-radius: 20px;
    margin-top: 27px;
  }
  .status-img {
    width: 88px;
    height: 88px;
    margin: 0 auto;
  }
  .check-info {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(53, 53, 53, 1);
    line-height: 24px;
  }
  .check-status {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(53, 53, 53, 1);
    text-align: center;
    margin: 20px 0 40px;
  }
  .check-btn {
    width: 215px;
    height: 50px;
    background: rgba(0, 48, 120, 1);
    border-radius: 25px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 50px;
    text-align: center;
    color: rgba(255, 255, 255, 1);
    margin: 50px 0 28px;
  }
  .record {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(53, 53, 53, 1);
  }
}
</style>